import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

export const experimentalGenerateSpaceKey: ExperimentalQueries['experimentalGenerateSpaceKey'] =
	async (_, { spaceName }, { network }) => {
		if (!spaceName) {
			throw new Error('space name is missing.');
		}

		try {
			const res = await network.cfetch(`/wiki/rest/onboarding/1/space/generate?key=${spaceName}`, {
				method: 'GET',
			});
			const { key } = await res.json();
			return { key };
		} catch (e) {
			throw new Error(`/space/generate ${e.message}`);
		}
	};
